module.exports = __webpack_public_path__ + "img/delete-active.53b86038.svg";